import React,  { useEffect }  from 'react';

import {logPageLoadEvents} from '@ibibo/analytics';

import * as S from './PreRegister.styles';

import SignUpBlock from './containers/SingUpBlock';

import HeaderPartner from '../../stories/components/Header/Header';
import FooterPartner from '../../stories/components/Footer/Footer';
import JoinUs from '../../stories/components/JoinUs/JoinUs';
import Benefits from '../../stories/components/BenefitsBlock/Benefits';
import MySafety from '../../stories/components/MySafety/MySafety';
import PerfectStay from '../../stories/components/PerfectStay/PerfectStay';
import InfoBlock from '../../stories/components/InfoBlock/InfoBlock';
import InfoStrip from '../../stories/components/InfoBlock/InfoStrip';

import {Arc} from '../../stories/components/Onboarding/onboarding.styles';

const PreRegister = () => {
  useEffect(() => {
    logPageLoadEvents('leadform:landing', {});
  }, []);

  return (
    <S.HomeWrapper>
      <HeaderPartner userType="preregister" />
      <S.PageMainWrapper>
        <InfoBlock />
        <SignUpBlock />
      </S.PageMainWrapper>
      <InfoStrip />
      <Benefits />
      <Arc />
      <MySafety />
      <PerfectStay />
      <JoinUs />
      <FooterPartner />
    </S.HomeWrapper>
  );
};

export default PreRegister;
